document.addEventListener("DOMContentLoaded", () => {
  const dropdownDiv = document.querySelector("#dropdown-menu-account");
  const dropdownMobileDiv = document.querySelector("#dropdown-menu-account-mobile");
  if (dropdownDiv) {
    setTimeout(() => {
      dropdownDiv.setAttribute("role", "dialog");
      dropdownMobileDiv.setAttribute("role", "dialog");
    }, 300);
  }
  const triggerButtonMobile = document.querySelector("#dropdown-trigger-links-mobile");
  if (triggerButtonMobile) {
    triggerButtonMobile.addEventListener("click", () => {
      dropdownMobileDiv.setAttribute("aria-modal", "true");
    });
  }
});
